

export const NEONPV_CONFIG = {
  HOSTNAME : 'http://3.35.108.23:3002', //for develop
  // HOSTNAME : 'http://3.36.30.180:3002', //for release
};

export const SIREN_CONFIG = {
  HOSTNAME : 'https://sirencare.net/api', //for release (nginx가 /api를 내부 4003으로 프록시함, Mixed Content 방지)
    // HOSTNAME : 'http://3.38.16.251:4003', //for release (구버전, https 페이지에서 Mixed Content 에러 발생)
    // HOSTNAME : 'http://13.209.117.218:4003', //for release
//    HOSTNAME : 'http://172.31.9.20:4003', //for develop, bighave local server  - fail
  //  HOSTNAME : 'http://localhost:4003', //for develop, bighave local server - fail, local pc로 인식함.
//    HOSTNAME : 'http://127.0.0.1:4003', //for develop, bighave local server - fail, local pc로 인식함.
//    HOSTNAME : 'http://localhost:4003', //for develop, bighave local server - fail, local pc로 인식함.

//  HOSTNAME : 'http://192.168.0.14:4003', //for develop, bighave local server
//  HOSTNAME : 'http://localhost:4003', //for develop, bighave local server
  //HOSTNAME : 'http://192.168.0.5:4003', //for develop
};

// export const FirebaseRootRef = "/wongwang_gunsan";
// export const FirebaseRootRef = "/wongwang";


export const CONFIG_SETTINGS = {
  FIREBASE_ROOT : "FirebaseRoot",
  USER_INFO : "userinfo",

  EmergencyRowsPerPage : "EmergencyRowsPerPage",
  CautionRowsPerPage: "CautionRowsPerPage",
  DeviceRowsPerPage: "deviceRowsPerPage",

  DEFAULT_EmergencyRowsPerPage: 5,
  DEFAULT_CautionRowsPerPage: 5,
  DEFAULT_DeviceRowsPerPage: 5,


  DisplayDeviceHealthCheck: "Display_Device_Health_Check",


  DeviceListRowsPerPage: "DeviceListRowsPerPage",

  AlertWakeUp: "Alert_Wakeup",
  Wakeup_Start_Time : "Wakeup_Start_Time",
  Wakeup_End_Time : "Wakeup_End_Time",

  PLAY_WAKEUP_ALARM : "play_wakeup",
  PLAY_EMERGENCY_ALARM : "play_emergecny",


  TABLE_HEIGHT : 200,
}


//부재: lightgray , #d3d3d3
//미활동: lightyellow , #87ceeb
//활동: lightgreen,  #4caf50
//주의: #ff9800
//긴급: #f44336
export const SIREN_COLOR = {

  EMERGENCY_COLOR : "#f44336",
  CAUTION_COLOR: "#ff9800",
  SLEEP_COLOR: "#d3d3d3",
  ACTIVITY_COLOR: "#4caf50", //활동
  QUIVER_COLOR : "#87ceeb", //미동
  NON_ACTIVITY_COLOR: "#b0c4de", //미활동

  ABSENCE_COLOR : "#d3d3d3", //부재
  OTHERS_COLOR: "#7F7F7F",


  EMERGENCY_BG_COLOR : "#f4433699",
  CAUTION_BG_COLOR: "#ff980099",
  SLEEP_BG_COLOR: "#d3d3d399",
  ACTIVITY_BG_COLOR: "#4caf5099", //활동
  QUIVER_BG_COLOR : "#87ceeb99", //미동
  NON_ACTIVITY_BG_COLOR: "#b0c4de99", //미활동
  ABSENCE_BG_COLOR : "#d3d3d399",  //부재
  OTHERS_BG_COLOR: "#7F7F7F99",


  EMERGENCY_BG2_COLOR : "#f44336CC",
  EMERGENCY_BG3_COLOR : "#f4433633",
  CAUTION_BG2_COLOR: "#ff9800CC",
  SLEEP_BG2_COLOR: "#d3d3d3CC",
  ACTIVITY_BG2_COLOR: "#4caf50CC", //활동
  QUIVER_BG2_COLOR : "#87ceebCC", //미동
  NON_ACTIVITY_BG2_COLOR: "#b0c4deCC", //미활동
  ABSENCE_BG2_COLOR : "#d3d3d3CC", //부재

  WAKEUP_BG2_COLOR : "#F8AC55CC", //기상
  WAKEUP_BG3_COLOR : "#F8AC5522", //기상

  OTHERS_BG2_COLOR: "#7F7F7FCC",

  SIREN_SYMBOL_COLOR: "#F4623A", //siren care 기본 색상
  SIREN_SYMBOL_COLOR2: "#F4623ADD", //siren care 기본 색상
  DEVICE_ERROR_COLOR: "#F4623A",


  DARK_GRAY: "#616161", //dark gray
}


export const SIREN_STATUS_LABEL = {
  EMERGENCY_LABEL : "긴급",
  EMERGENCY_LABEL_EN : "EMERGENCY",
  FALL_LABEL : "낙상",
  FALL_LABEL_EN : "EMERGENCY",
  CAUTION_LABEL: "주의",
  CAUTION_LABEL_EN: "CAUTION",
  ACTIVITY_LABEL: "활동",
  ACTIVITY_LABEL_EN: "ACTIVITY",
  QUIVER_LABEL : "미동",
  QUIVER_LABEL_EN : "QUIVER",
  NON_ACTIVITY_LABEL: "미활동",
  NON_ACTIVITY_LABEL_EN: "NON_ACTIVITY",
  PRESENCE_LABEL : "재실",
  PRESENCE_LABEL_EN : "PRESENCE",
  ABSENCE_LABEL : "부재",
  ABSENCE_LABEL_EN : "ABSENCE",
  DEVICE_ERROR_LABEL : "점검",
  DEVICE_ERROR_LABEL_EN : "DEVICE_ERROR",
  WAKEUP_LABEL : "기상",
  WAKEUP_LABEL_EN : "WAKEUP"
}

export const SIREN_BOARD_TITLE_HEIGHT = 42;
export const SIREN_BOARD_ITEM_HEIGHT = 40;

/**
 * 시스템 최상위 관리자
 */
export const USERAUTH_ADMIN = 1;

/**
 * 각 시설 관리자
 */
export const USERAUTH_USER = 2;

// https://reactnative.dev/docs/colors
